const entityTypeIds = {
    applet: 7,
};

export default entityTypeIds;
